import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const SimpleOutlookIcon = withTheme(
  ({ title, theme, width, height, viewBox = "0 0 512 482", type }) => (
    <svg
      width={width}
      height={height}
      title={title}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
    >
      <g fill="none" fillRule="evenodd">
        <g
          fill={
            type === "alternative" ? theme.onPrimaryColor : theme.primaryColor
          }
          fillRule="nonzero"
        >
          <g>
            <path d="M496 97.011H288v-80c0-4.768-2.112-9.28-5.792-12.32-3.648-3.04-8.544-4.352-13.152-3.392l-256 48C5.472 50.707 0 57.299 0 65.011v352c0 7.68 5.472 14.304 13.056 15.712l256 48c.96.192 1.952.288 2.944.288 3.712 0 7.328-1.28 10.208-3.68 3.68-3.04 5.792-7.584 5.792-12.32v-80h208c8.832 0 16-7.168 16-16v-256c0-8.832-7.168-16-16-16zm-352 256c-44.096 0-80-43.072-80-96s35.904-96 80-96 80 43.072 80 96-35.904 96-80 96zm144-224h161.376l-98.304 76.448L288 165.363v-36.352zm192 224H288V203.283l55.392 35.232c2.624 1.664 5.632 2.496 8.608 2.496 3.456 0 6.944-1.12 9.824-3.36L480 145.715v207.296z" />
            <ellipse cx="144" cy="257.01" rx="48" ry="64" />
          </g>
        </g>
      </g>
    </svg>
  )
);

export const OutlookIcon = ({ type, title }) => (
  <Icon>
    <SimpleOutlookIcon
      width="30"
      height="30"
      viewBox="0 0 512 482"
      title={title}
      type={type}
    />
  </Icon>
);

OutlookIcon.propTypes = {
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  title: PropTypes.string
};

OutlookIcon.defaultProps = {
  title: "Outlook Icon",
  type: "secondary"
};

export default withTheme(OutlookIcon);
